/* CouchQuest theme – small progressive enhancements, no dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  /* Übersetzte Texte aus snippets/cq-js-strings.liquid (window.cqT); ohne Eintrag gilt der deutsche Standardtext. {name} wird ersetzt. */
  const tr = (key, fallback, vars) => {
    let s = (window.cqT && window.cqT[key]) || fallback;
    if (vars) Object.keys(vars).forEach((v) => { s = s.split('{' + v + '}').join(vars[v]); });
    return s;
  };

  /* Toast + cart count */
  const toast = (msg) => {
    const t = $('#CartToast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._h);
    t._h = setTimeout(() => (t.hidden = true), 2600);
  };
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });

  /* Mobile menu */
  const menu = $('[data-menu]');
  const openBtn = $('[data-menu-open]');
  if (menu && openBtn) {
    const close = () => { menu.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); openBtn.classList.remove('is-open'); document.body.style.overflow = ''; };
    openBtn.addEventListener('click', () => {
      if (!menu.hidden) return close();
      menu.hidden = false; openBtn.setAttribute('aria-expanded', 'true'); openBtn.classList.add('is-open'); document.body.style.overflow = 'hidden';
    });
    menu.addEventListener('click', (e) => { if (e.target === menu) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) close(); });
  }

  /* Gallery */
  const gallery = $('[data-gallery]');
  if (gallery) {
    const slides = $$('[data-slide]', gallery);
    const thumbs = $$('[data-thumb]', gallery);
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.hidden = k !== i; s.classList.toggle('is-active', k === i); });
      thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
      thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      slides.forEach((s, k) => { if (k !== i) s.querySelectorAll('video').forEach((v) => v.pause()); });
      // Trailer startet automatisch (stumm, wie Browser es erlauben); Ton per Button
      slides[i].querySelectorAll('video').forEach((v) => { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(+t.dataset.thumb)));
    $$('[data-sound]', gallery).forEach((b) => b.addEventListener('click', () => {
      const v = b.parentElement.querySelector('video'); if (!v) return;
      v.muted = !v.muted; if (!v.muted && v.paused) v.play();
      b.setAttribute('aria-pressed', String(!v.muted)); b.querySelector('span').textContent = v.muted ? tr('sound_on', 'Ton an') : tr('sound_off', 'Ton aus');
    }));
    // Beim Scrollen: Trailer nur abspielen, solange die Galerie im Bild ist
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => es.forEach((e) => {
      const v = slides[i]?.querySelector('video'); if (!v) return;
      if (e.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause();
    }), { threshold: 0.35 }).observe(gallery);
    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => show(i - 1));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => show(i + 1));
    let x0 = null;
    const stage = $('.pdp__stage', gallery);
    stage.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* Gift toggle: fields are disabled (not submitted) unless the switch is on */
  $$('[data-gift]').forEach((g) => {
    const toggle = $('[data-gift-toggle]', g);
    const fields = $('fieldset', g);
    toggle.addEventListener('change', () => {
      fields.hidden = !toggle.checked;
      fields.disabled = !toggle.checked;
      if (toggle.checked) $('input', fields).focus();
    });
  });

  /* Product form: AJAX add; "Jetzt kaufen" continues to the cart (consent step) */
  $$('.js-product-form').forEach((form) => {
    let goToCart = false;
    $('[data-buy-now]', form)?.addEventListener('click', () => (goToCart = true));
    $('[data-add]', form)?.addEventListener('click', () => (goToCart = false));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const err = $('[data-form-error]', form);
      err.hidden = true;
      const gift = $('fieldset:not([disabled])', form);
      if (gift) {
        const invalid = $$('input, textarea', gift).find((el) => !el.checkValidity());
        if (invalid) { invalid.reportValidity(); return; }
      }
      const btns = $$('button[type=submit]', form);
      btns.forEach((b) => (b.disabled = true));
      try {
        const res = await fetch(window.CQ.routes.cartAdd + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message);
        if (goToCart) { window.location.href = window.CQ.routes.cart; return; }
        if (!(window.CQ.openCart && window.CQ.openCart())) {
          const cart = await (await fetch(window.CQ.routes.cartJs)).json();
          setCount(cart.item_count);
          toast(window.CQ.strings.added);
        }
      } catch (ex) {
        err.textContent = ex.message || window.CQ.strings.error;
        err.hidden = false;
      } finally {
        btns.forEach((b) => (b.disabled = false));
      }
    });
  });

  /* Card quick-add */
  $$('.js-add-form').forEach((form) => form.addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(window.CQ.routes.cartAdd + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error();
      if (!(window.CQ.openCart && window.CQ.openCart())) {
        const cart = await (await fetch(window.CQ.routes.cartJs)).json();
        setCount(cart.item_count);
        toast(window.CQ.strings.added);
      }
    } catch { toast(window.CQ.strings.error); }
  }));

  /* Cart: swap single games for the bundle (only offered when no gift/multi-licence lines are involved) */
  $$('[data-bundle-swap]').forEach((btn) => btn.addEventListener('click', async () => {
    btn.disabled = true;
    try {
      const updates = {};
      btn.dataset.keys.split(',').filter(Boolean).forEach((k) => (updates[k] = 0));
      const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      await fetch(window.CQ.routes.cartUpdate + '.js', { method: 'POST', headers: json, body: JSON.stringify({ updates }) });
      const res = await fetch(window.CQ.routes.cartAdd + '.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1, properties: { [window.CQ.props.access]: window.CQ.props.accessMany || 'Startlinks per E-Mail von play.couchquest.de' } }] }) });
      if (!res.ok) throw new Error();
      location.reload();
    } catch {
      toast(window.CQ.strings.error);
      btn.disabled = false;
    }
  }));

  /* Sticky buy bar on mobile PDP: visible once the main button scrolled away */
  const sticky = $('[data-sticky-buy]');
  const mainBuy = $('[data-buy-now]');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }).observe(mainBuy);
    $('[data-sticky-trigger]', sticky).addEventListener('click', () => mainBuy.click());
  }

  /* Collection: sort + filter auto-submit */
  $$('.js-sort').forEach((sel) => sel.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', sel.value);
    location.href = u.toString();
  }));
  /* Collection: Filter als Drawer */
  (() => {
    const drawer = $('#FilterDrawer'); if (!drawer) return;
    const backdrop = $('.filter-backdrop');
    const open = () => { drawer.hidden = false; backdrop.hidden = false; requestAnimationFrame(() => { drawer.classList.add('is-open'); backdrop.classList.add('is-open'); }); document.body.style.overflow = 'hidden'; };
    const close = () => { drawer.classList.remove('is-open'); backdrop.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(() => { drawer.hidden = true; backdrop.hidden = true; }, 250); };
    $$('[data-filter-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-filter-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
  })();

  /* Cart: quantity change + consent gate */
  const cartForm = $('#CartForm');
  if (cartForm) {
    $$('.js-qty', cartForm).forEach((inp) => inp.addEventListener('change', () => {
      cartForm.querySelector('[name=checkout]').removeAttribute('name');
      const h = document.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1';
      cartForm.appendChild(h);
      cartForm.submit();
    }));
    const consent = $('[data-consent]', cartForm);
    consent?.addEventListener('change', () => {
      consent.closest('.consent').classList.remove('is-missing');
      const body = new FormData();
      body.append('attributes[' + window.CQ.props.consent + ']', consent.checked ? window.CQ.props.yes : '');
      body.append('attributes[' + window.CQ.props.consentTime + ']', consent.checked ? new Date().toISOString() : '');
      fetch(window.CQ.routes.cartUpdate + '.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
    });
    $('[data-checkout]', cartForm)?.addEventListener('click', (e) => {
      if (consent && !consent.checked) {
        e.preventDefault();
        consent.closest('.consent').classList.add('is-missing');
        consent.focus();
        toast(tr('consent_required', 'Bitte bestätige die Zustimmung, um fortzufahren.'));
      }
    });
  }
})();
